import { FC, HTMLAttributes } from 'react';
import cn from 'utils/cn';

type TProps = {
  label: string;
};

const InstructionsLabel: FC<TProps & HTMLAttributes<HTMLDivElement>> = ({ label, ...rest }) => {
  return (
    <div className={cn('tw:pb-1 tw:font-light tw:text-xs/4 tw:max-w-[400px]', rest?.className)}>
      {label}
    </div>
  );
};

export default InstructionsLabel;
